import { ButtonType, ButtonWidget } from '@tableau/widgets';
import React = require('react');
import { Messages } from '~src/codegen/Localize';
import { FileInput } from '~src/userManagement/components/FileInput';

import { AddServiceAccountDialogStyles } from '../styles/AddServiceAccountDialogStyles';
import { AuthModeProps, AuthModeState } from './AddCredentialAuthModeDialog';

const VALID_FILE_TYPES = ['.json'];

export interface ServiceAccountAuthState {
    file?: File;
    fileName?: string;
}

export class AddServiceAccountCredentialDialog extends React.Component<AuthModeProps, ServiceAccountAuthState> {
    props: AuthModeProps;
    state: ServiceAccountAuthState;
    localFile: File;
    fileName: string;
    fileElement: any;
    fileInput: React.RefObject<HTMLInputElement>;

    public constructor(props: AuthModeProps, state: AuthModeState) {
        super(props);
        this.state = {file: this.localFile, fileName: ''};
        this.fileInput = React.createRef();
        this.props.parentState.connAuthState = {file: this.localFile};
    }

    private handleFileSelection = (fileUploaded: File | undefined) => {
        // Only set the file if a user has selected a file. They may have hit cancel
        if (fileUploaded) {
            // Set the name of the file and set the current file reference.
            this.localFile = fileUploaded;
            this.setState({ file: fileUploaded, fileName: this.localFile.name });
            this.props.parentState.connAuthState.file = this.localFile;
        }
    };

    private triggerFileInput = () => {
        this.fileInput.current.click();
    };

    public render(): JSX.Element {
        return (<>
        <div className={AddServiceAccountDialogStyles.fileSelectionContainer}>
            <FileInput
                accept={VALID_FILE_TYPES.join(',')}
                handleFileInput={this.handleFileSelection}
                name='file'
                ref={this.fileInput}
                testId='service-account-credential-input-file-id'
            />
            <div className={AddServiceAccountDialogStyles.dragAndDropChildren}>
            {this.state.fileName !== '' &&
                <b className={AddServiceAccountDialogStyles.fileName}>{this.state.fileName}</b>
            }
            <ButtonWidget
                buttonType={ButtonType.Outline}
                type="button"
                testId="upload-service-account-browse"
                children={Messages.contentUpload_chooseAFile()}
                handleClick={this.triggerFileInput}
            />
            </div>
    </div>
    <div>
        <p className={AddServiceAccountDialogStyles.uploadServiceAccountFileDescription} id="upload-service-account-message">
              {Messages.addNewSavedCredentialServiceAccountFileDetails()}
        </p>
    </div></>);
}
}
export const AddServiceAccountCredential: React.ComponentType<AuthModeProps> =
  AddServiceAccountCredentialDialog;